import React, { memo } from 'react';
import { Controller } from 'react-hook-form';
import { Grid, TextField } from '@mui/material';

import { PARCEL_NUMBER } from '../../../constants/strings';
import ParcelSearchButtons from './ParcelSearchButtons';
import ParcelSearchResult from './ParcelSearchResult';

const ParcelSearchForm = ({
  handleFinish,
  handleReset,
  handleSearch,
  control,
  foundParcels,
  disableSearchButton,
  validateParcelNumber,
  errors,
}) => (
  <>
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Controller
          name="parcelNumber"
          control={control}
          rules={{ validate: validateParcelNumber }}
          render={({ field }) => (
            <TextField
              {...field}
              label={PARCEL_NUMBER}
              variant="outlined"
              data-testid="parcel-number"
              fullWidth
              onBlur={field.onBlur}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <ParcelSearchResult
          results={foundParcels}
          errors={errors}
          onClose={handleFinish}
        />
      </Grid>
      <Grid item xs={12}>
        <ParcelSearchButtons
          handleSearch={handleSearch}
          handleReset={handleReset}
          handleFinish={handleFinish}
          disableSearchButton={disableSearchButton}
        />
      </Grid>
    </Grid>
  </>
);

export default memo(ParcelSearchForm);
